import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
  },
  iconAndTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#f5f5f5',
    color: '#FF4500',
  },
  title: {
    fontWeight: 600,
    fontSize: '16px',
    marginBottom: theme.spacing(0.5),
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  statusText: {
    fontSize: '14px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  requiredChip: {
    width: 'fit-content',
    backgroundColor: '#FF4500',
    color: '#fff',
    fontWeight: 600,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: '1px solid #e0e0e0',
  },
  deleteButton: {
    color: '#d32f2f',
    '&:hover': {
      backgroundColor: 'rgba(211, 47, 47, 0.1)',
    },
  },
  activateButton: {
    color: '#FF4500',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'rgba(255, 69, 0, 0.1)',
    },
  },
}))

export default useStyles
